import { render, staticRenderFns } from "./HealthChecks.vue?vue&type=template&id=8b95013e&scoped=true&"
import script from "./HealthChecks.vue?vue&type=script&lang=js&"
export * from "./HealthChecks.vue?vue&type=script&lang=js&"
import style0 from "./HealthChecks.vue?vue&type=style&index=0&id=8b95013e&scoped=true&lang=scss&"
import style1 from "./HealthChecks.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b95013e",
  null
  
)

export default component.exports